import { ROLES } from '@/features/auth/types';

interface TenantAccessParams {
  usertenant_id: string | null | undefined;
  targettenant_id: string | null | undefined;
  userRole?: string | null;
}

/**
 * Verifica se o usuário tem permissão de superadmin
 * @throws {Error} Se o usuário não tiver permissão
 */
export const checkSuperAdminPermission = (userRole?: string | null) => {
  if (!userRole || userRole !== ROLES.SUPER_ADMIN) {
    throw new Error('Acesso não autorizado - necessário perfil de superadmin');
  }
};

/**
 * Verifica se o usuário tem acesso ao tenant específico
 * @throws {Error} Se o usuário não tiver permissão
 */
export function checkTenantAccess(userTenantId: string | null, targetTenantId: string | null, userRole: string | null = null): void {
  if (userRole === ROLES.SUPER_ADMIN) return;
  
  if (!userTenantId) {
    throw new Error("Acesso negado: usuário sem tenant");
  }

  if (targetTenantId && userTenantId !== targetTenantId) {
    throw new Error("Acesso negado: tenant inválido");
  }
}

/**
 * Verifica se o usuário tem acesso ao recurso (contrato, cliente, etc)
 * @param userTenantId O tenant do usuário logado
 * @param resourceTenantId O tenant do recurso sendo acessado
 * @param userRole O role do usuário
 * @param resourceType Tipo de recurso sendo acessado (para mensagens de erro)
 * @throws {Error} Se o usuário não tiver permissão
 */
export function checkResourceAccess(
  userTenantId: string | null,
  resourceTenantId: string | null,
  userRole: string | null = null,
  resourceType: string = 'recurso'
): void {
  // Superadmin pode acessar qualquer recurso
  if (userRole === ROLES.SUPER_ADMIN) return;
  
  // Se não for superadmin, precisa ter um tenant
  if (!userTenantId) {
    throw new Error('Usuário sem tenant associado');
  }
  
  // Se não for superadmin, só pode acessar recursos do próprio tenant
  if (!resourceTenantId || userTenantId !== resourceTenantId) {
    throw new Error(`Acesso não autorizado a este ${resourceType}`);
  }
}

/**
 * Verifica se um usuário pode editar um recurso
 * @param resourceStatus Status do recurso
 * @param allowedStatuses Lista de status que permitem edição
 * @param userRole O role do usuário
 * @throws {Error} Se o recurso não puder ser editado
 */
export function checkEditPermission(
  resourceStatus: string,
  allowedStatuses: string[] = ['pendente', 'em_preenchimento'],
  userRole: string | null = null
): void {
  // Superadmin pode editar independente do status
  if (userRole === ROLES.SUPER_ADMIN) return;
  
  // Verifica se o status do recurso permite edição
  if (!allowedStatuses.includes(resourceStatus)) {
    throw new Error('Este item não pode ser editado no status atual');
  }
}
